import React from "react";
import MotifAction from "../../core-components/Menu/Item";
import { Motif2DeprecationWarning } from "../../utils/internal";

export default function Action(props) {
  Motif2DeprecationWarning("GlobalActionButton", "MenuButton");

  return <MotifAction {...props} />;
}
